import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { footerLinks, siteInfo } from "@/mocks/site";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <section className="bg-primary-950 pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="w-full px-4 md:px-8">
          <p className="font-heading font-bold text-6xl md:text-8xl text-primary-800 leading-none mb-6">404</p>
          <h1 className="font-heading font-bold text-2xl md:text-4xl text-background-50">
            这条通道不存在或已经关闭
          </h1>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200 max-w-xl">
            你访问的地址是 <span className="text-accent-300 break-all">{location.pathname}</span>
            ，但{siteInfo.fullName}上没有对应的页面。可能是链接有误，也可能是内容已按流程下架。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap bg-accent-500 text-primary-950 hover:bg-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-home-4-line" aria-hidden="true"></i>
              返回首页
            </Link>
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-medium whitespace-nowrap border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-lock-2-line" aria-hidden="true"></i>
              进入匿名投稿
            </Link>
          </div>

          <nav aria-label="站点导航" className="mt-14 pt-8 border-t border-primary-900">
            <ul className="flex flex-wrap gap-x-6 gap-y-3">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 hover:text-accent-300 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </section>
    </SiteLayout>
  );
}